;(function () {
  // Banners "OfferteHotel" e "LastMinute" in multiple pages
  if (
    [
      123, // dove dormire
      125, // meteo
      110, // agriturismi
      70, // rifugi e baite
      40, // b&b
      22, // hotel
    ].indexOf(WC?.idMenu) > -1
  ) {
    document
      .querySelector('.c-item')
      ?.appendChild(getBannerContainer(...Object.values(getBanners())))
  }

  // Banner "OfferteHotel" in last minute page
  if (WC?.idSottoMenu === 55) {
    document.querySelector('.body-page')?.appendChild(getBannerContainer(getBanners().offertehotel))
  }

  // Banner "LastMinute" in hotel offers page
  if (WC?.idSottoMenu === 54) {
    document.querySelector('.body-page')?.appendChild(getBannerContainer(getBanners().lastminute))
  }

  // Functions
  function getBanners() {
    return {
      offertehotel: getBanner(
        {
          summer: '/images/web/dormire/offerte.jpg',
          winter: '/images/web/dormire/offerte_inverno.jpg',
        },
        {
          url: {
            it: '/it/alberghi/offerte_alberghi_asiago/',
            en: '/en/hotels/hotel_offers/',
            de: '/de/hotels/angebote_hotels/',
          },
          alt: {
            it: 'Offerte Dove Dormire',
            en: 'Offers Where to sleep',
            de: 'Bietet an, wohin zu bleiben',
          },
          overtitle: {
            it: 'Scopri le',
            en: 'Discover',
            de: 'Entdecken',
          },
          title: {
            it: 'Offerte speciali di soggiorno',
            en: 'Special stay offers',
            de: 'Spezielle Aufenthaltsangebote',
          },
          button: {
            it: 'Scopri',
            en: 'Discover',
            de: 'Entdecken',
          },
        }
      ),
      lastminute: getBanner(
        {
          summer: '/images/web/dormire/lastminute.jpg?v=2',
          winter: '/images/web/dormire/lastminute.jpg?v=2',
        },
        {
          url: {
            it: '/it/alberghi/last_minute_hotel_asiago/',
            en: '/en/hotels/last_minute_hotel_asiago_plateau/',
            de: '/de/hotels/last_minute_hochebene_asiago/',
          },
          alt: {
            it: 'Offerte Last Minute Hotel',
            en: 'Offer last minute hotel',
            de: 'Bieten Last Minute Hotel an',
          },
          overtitle: {
            it: 'Scopri le',
            en: 'Discover',
            de: 'Entdecken',
          },
          title: {
            it: "Offerte last-minute sull'Altopiano",
            en: 'Last-minute offers on the Plateau',
            de: 'Last-Minute-Angebote auf dem Plateau',
          },
          button: {
            it: 'Scopri',
            en: 'Discover',
            de: 'Entdecken',
          },
        }
      ),
    }
  }

  function getBannerContainer(...banners) {
    const bannersCnt = document.createElement('div')
    bannersCnt.classList.add('banner-generic-cnt')
    bannersCnt.append(...banners)
    return bannersCnt
  }

  function getBanner(images, texts) {
    const node = document.createElement('a')
    node.classList.add('banner-generic', 'dkreset')
    node.href = mL(texts.url)

    node.innerHTML = /* html */ `
			<div class="banner-generic__photo">
				<figure class="banner-generic__picture">
					<img src="${sI(images)}" alt="${mL(texts.alt)}" class="banner-generic__image">
				</figure>
			</div>
			<div class="banner-generic__text">
				<div class="banner-generic__overtitle">${mL(texts.overtitle)}</div>
				<div class="banner-generic__title">${mL(texts.title)}</div>
				<div class="banner-generic__button">
					<div class="banner-generic__btntext">${mL(texts.button)}</div>
				</div>
			</div>`

    return node
  }

  function mL(text) {
    return text[WC.lang.substr(0, 2)]
  }

  function sI(images) {
    if (WC?.PageVars?.season === 4) {
      return images.winter
    } else {
      return images.summer
    }
  }
})()
